import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CHUONGTRINHHOC_API, CHUYENNGANH_API } from '@app/utils/apiUrl';
import { Get, Post } from '@app/utils/httpProvider';
import { messageError, messageToast, status200, styleSelectDefault } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { Button } from '@components';
import Editor from '@app/components/editor/Editor';
import { useMutation } from 'react-query';
import {AsyncPaginate} from 'react-select-async-paginate';

const schema = yup.object().shape({
    tenChuongTrinhHoc: yup.string().required(messageError.emptyMessage)
});

const ChuongTrinhHocAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(CHUONGTRINHHOC_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = {
            ...values,
        };

        model.chuyenNganhId =
            values.chuyenNganhId === '' ||
                values.chuyenNganhId === 'null' ||
                values.chuyenNganhId === undefined
                ? ''
                : values.chuyenNganhId.value;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const loadOptionsChuyenNganh = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(CHUYENNGANH_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.maChuyenNganh} - ${x.tenChuyenNganh}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới chương trình học</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tenChuongTrinhHoc: '',
                        chuyenNganhId: '',
                        moTa: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={2}>Tên chương trình học</Form.Label>
                                <Col sm={10}>
                                    <Form.Control
                                        name="tenChuongTrinhHoc"
                                        value={values.tenChuongTrinhHoc}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenChuongTrinhHoc}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenChuongTrinhHoc}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3 align-items-center">
                                <Form.Label column sm={2}>Chuyên ngành</Form.Label>
                                <Col sm={10}>
                                    <AsyncPaginate
                                        name="chuyenNganhId"
                                        id="chuyenNganhId"
                                        placeholder="Chọn chuyên ngành"
                                        value={values.chuyenNganhId}
                                        loadOptions={loadOptionsChuyenNganh}
                                        styles={styleSelectDefault}
                                        isClearable
                                        onChange={(selectedOption) => {
                                            // const event = {
                                            //     target: {
                                            //         name: 'accountPatients',
                                            //         value: selectedOption
                                            //     }
                                            // };
                                            // setAccountHisId(event);
                                            setFieldValue(
                                                'chuyenNganhId',
                                                selectedOption,
                                                true
                                            );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />
                                    <div
                                        style={{
                                            display: 'block',
                                            color: '#dc3545'
                                        }}
                                        className="invalid-feedback"
                                    >
                                        {errors.chuyenNganhId}
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'moTa',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.CHUONGTRINHHOC_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default ChuongTrinhHocAdd;
